document.addEventListener('DOMContentLoaded', function () {
    const HTML = document.documentElement
    function toggleScroll (open, modalName = '') {
        if (open) {
            HTML.classList.add('no-scroll')
            if (modalName !== 'QUICK-ADD-MODAL') {
              scrollLock.disablePageScroll();
            }
        } else {
            HTML.classList.remove('no-scroll')
            scrollLock.enablePageScroll();
        }
    }

    // dont call scrollLock for certain use cases like filters
    function toggleScrollHTML (open) {
        if (open) {
            HTML.classList.add('no-scroll')
        } else {
            HTML.classList.remove('no-scroll')
        }
    }

    // header search modal
    const searchModal = document.querySelector('.header__search > details')
    if (searchModal) {
        searchModal.addEventListener("toggle", (event) => {
            toggleScrollHTML(searchModal.open)
        });
    }

    // cart drawer
    const cartDrawers = document.querySelectorAll('cart-drawer.drawer')
    if (cartDrawers.length > 0 && !document.querySelector('body').classList.contains('template-cart')) {
        var drawerObserver = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === "attributes") {
                    const open = mutation.target.classList.contains('active')
                    toggleScroll(open)
                    if (open) {
                        scrollLock.enablePageScroll(document.querySelector('#CartDrawer-Form'));
                    }
                }
            });
        });
        for (const element of cartDrawers) {
            drawerObserver.observe(element, {
                attributes: true
            });
        }
    }

    // size guide pop up
    const sizeGuides = document.querySelectorAll('.size-guide__popup')
    if (sizeGuides.length > 0) {
        var sizeGuideObserver = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === "attributes") {
                    toggleScrollHTML(!mutation.target.classList.contains('hidden'))
                }
            });
        });
        for (const element of sizeGuides) {
            sizeGuideObserver.observe(element, {
                attributes: true
            });
        }
    }

    // back in stock modal, quick view/add
    document.body.addEventListener('modalClosed', () => {toggleScroll(false)});
    document.body.addEventListener('modalOpened', (e) => {toggleScroll(true, e.detail)});
    // collection filters
    document.body.addEventListener('modalClosedHTML', () => {toggleScrollHTML(false)});
    document.body.addEventListener('modalOpenedHTML', () => {toggleScrollHTML(true)});
});